/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DataService_Models_SurveyProgressBarType {
    NONE = 'none',
    PROGRESS_STEP = 'progressStep',
    PROGRESS_PERCENTAGE = 'progressPercentage',
}
